export const self_order_url: string = "self_order";